import { Injectable, inject } from '@angular/core';

import { Page } from '../client-config/page.client-config';
import { LastKnownProductService } from '../last-known-product/last-known-product.service';
import { NativeAppService } from '../native-app/native-app.service';
import { NavigationService } from '../navigation/navigation.service';
import { ParsedUrl } from '../navigation/parsed-url';
import { UrlService } from '../navigation/url.service';
import { ProductHomepagesConfig } from '../products/product-homepages.client-config';

/**
 * @stable
 */
@Injectable({
    providedIn: 'root',
})
export class HomeService {
    private readonly navigation = inject(NavigationService);
    private readonly page = inject(Page);
    private readonly lastKnownProductService = inject(LastKnownProductService);
    private readonly url = inject(UrlService);
    private readonly productHomepages = inject(ProductHomepagesConfig);
    private readonly nativeApp = inject(NativeAppService);

    /** Navigates to home page. Calls goToNativeApp for native app. For wrapper app navigates to app's product homepage */
    goTo(isBackNavigation = true) {
        if (this.nativeApp.isNativeApp) {
            this.navigation.goToNativeApp();
        } else {
            const homeUrl = this.getUrl();
            this.navigation.goTo(homeUrl, { isBackNavigation });
        }
    }

    /** Gets home url. */
    getUrl(): ParsedUrl {
        let homeUrl;

        if (this.nativeApp.isNativeWrapper) {
            homeUrl = this.url.parse((this.productHomepages as any)[this.getCommonName(this.nativeApp.product)]);
        } else {
            const lkp = this.lastKnownProductService.get();
            homeUrl = this.url.parse(lkp.url);
        }

        homeUrl.changeCulture(this.page.lang);

        return homeUrl;
    }

    private getCommonName(product: string): string {
        if (product === 'BETTING' || product === 'SPORTSBOOK') {
            return 'sports';
        }

        return product.toLowerCase();
    }
}
